<cdk-virtual-scroll-viewport [itemSize]="treeNodeSize">
  <ng-container *cdkVirtualFor="let item of expandedNodesDataSource"></ng-container>

  <cdk-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <cdk-tree-node
      *cdkTreeNodeDef="let node"
      [attr.node-id]="'tree-node-' + node.id"
      class="tree-node"
      [style.marginLeft]="node.level * 22 + 20 + 'px'"
    >
      <ng-container *ngTemplateOutlet="template; context: { node: node }"></ng-container>
    </cdk-tree-node>

    <cdk-tree-node
      *cdkTreeNodeDef="let node; when: hasChild"
      [attr.node-id]="'tree-node-' + node.id"
      class="tree-node"
      [style.marginLeft]="node.level * 22 + 'px'"
    >
      <a
        cdkTreeNodeToggle
        [attr.aria-label]="'toggle ' + node.name"
        [class.tree-node--expanded]="treeControl.isExpanded(node)"
        class="tree-node-expander"
      >
      </a>

      <ng-container *ngTemplateOutlet="template; context: { node: node }"></ng-container>
    </cdk-tree-node>
  </cdk-tree>
</cdk-virtual-scroll-viewport>

<ng-template #template let-node="node">
  <mat-checkbox
    [checked]="node.state === ECheckboxState.Checked"
    [indeterminate]="node.state === ECheckboxState.Indeterminate"
    [disabled]="node.isDisabled"
    (change)="toggleSelection(node)"
    color="primary"
    >{{ node.name }}</mat-checkbox
  >
</ng-template>
